import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE, PRICE_OLD } from '../data/religione';
const recap = ['6 tomi', '5 bonus', '240 pagine', 'Primaria e Secondaria'];
const reassurances = ['Download digitale immediato', 'PDF stampabili', 'Garanzia di 7 giorni'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-117" data-mp="15c2fjcfz4tth">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-118" data-mp="1jbah2bzm0e0u" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-119" data-mp="1t2ydysexqn9p">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-120" data-mp="1t2ew1bpabyvo">
          Entra in aula con <em className="text-red-700" data-id="element-121" data-mp="1o67ndb5i89a1">tutto pronto.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-122" data-mp="2245ym7oj3plb">
          Invece di cercare schede, creare ogni attività da solo e passare le domeniche sera a
          programmare, hai un sistema di IRC organizzato per tutto l'anno scolastico. Più tempo per
          quello che conta davvero:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-123" data-mp="s6ijx7hdt4kh">
          I tuoi alunni. Le tue lezioni. La tua vita fuori dalla scuola.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-124" data-mp="1246dhu394612">
          {recap.map(item => <li key={item} data-id="element-125" data-mp="1b3a21dl6tdmy">{item}</li>)}
        </ul>

        <p className="mt-8 text-sm text-slate-900/60" data-id="element-126" data-mp="1b1yxvcnty3vb">invece di <s data-id="element-127" data-mp="1ftqeaud9ut7q">{PRICE_OLD}</s></p>
        <p className="mt-2 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-128" data-mp="1fvl0ec0a4rde">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-129" data-mp="1ksth085s4ncj">Pagamento unico – nessun abbonamento.</p>

        <div className="mt-8 flex justify-center" data-id="element-130" data-mp="1pu0u8mqoyeql">
          <CtaButton className="w-full sm:w-auto" data-id="element-131" data-mp="1ttrncx3ox6ya" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-132" data-mp="1tryj1ogjuytg">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-133" data-mp="3lvufjvwvvb6c">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-134" data-mp="3lthomt95dqh5" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}